/* Oilsu storefront behaviour (v1.2): qty steppers, variant + multi-option switching,
   ajax add to cart, cart count refresh, predictive search, mega menu,
   collection filter drawer, ingredient dictionary. No dependencies. */
(function () {
  if (window.__oilsuInit) return;
  window.__oilsuInit = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var money = function (cents) {
    var cur = window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  var countText = function (el, n) {
    return el.hasAttribute('data-count-items') ? (n === 1 ? '1 item' : n + ' items') : String(n);
  };

  /* ---------- qty steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    e.preventDefault();
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    var next = (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qtyStep, 10);
    input.value = Math.max(min, Math.min(9999, next));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- variant state (single select, or one select per option) ---------- */
  function applyVariant(box, variant) {
    var price = box.querySelector('[data-price]');
    var unit = box.querySelector('[data-unit]');
    var stock = box.querySelector('[data-stock]');
    var add = box.querySelector('[data-add]');
    var idEl = box.querySelector('[data-variant-id]');
    if (!variant) {
      if (stock) { stock.className = 'ot-stock is-out'; stock.textContent = 'Unavailable'; }
      if (add) { add.disabled = true; add.textContent = 'Unavailable'; }
      if (idEl) idEl.value = '';
      return;
    }
    var available = !!variant.available;
    var qty = variant.inventory == null ? null : parseInt(variant.inventory, 10);
    if (idEl) idEl.value = variant.id;
    if (price) price.textContent = money(parseInt(variant.price, 10));
    if (unit) unit.textContent = 'per ' + (variant.title || '').replace(/ \/ /g, ' \u00b7 ');
    if (stock) {
      var low = available && qty != null && qty > 0 && qty < 10;
      stock.className = 'ot-stock' + (!available ? ' is-out' : low ? ' is-low' : '');
      stock.textContent = !available ? 'Out of stock' : low ? 'Low \u00b7 ' + qty : 'In stock';
    }
    if (add) {
      add.disabled = !available;
      add.textContent = available ? (add.dataset.label || 'Add') : 'Sold out';
    }
    if (box.hasAttribute('data-product-form') && window.history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url.toString());
    }
  }

  var variantCache = {};
  function getVariants(box) {
    var tag = box.querySelector('script[data-variants]');
    if (tag) {
      if (!box.__variants) { try { box.__variants = JSON.parse(tag.textContent); } catch (e) { box.__variants = []; } }
      return Promise.resolve(box.__variants);
    }
    var handle = box.dataset.handle;
    if (!handle) return Promise.resolve([]);
    if (!variantCache[handle]) {
      variantCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          return (p.variants || []).map(function (v) {
            return { id: v.id, price: v.price, available: v.available, inventory: null, title: v.title, options: v.options };
          });
        })
        .catch(function () { delete variantCache[handle]; return []; });
    }
    return variantCache[handle];
  }

  function chosenOptions(box) {
    return Array.prototype.map.call(box.querySelectorAll('select[data-option-index]'), function (s) { return s.value; });
  }

  function resolveVariant(box) {
    var chosen = chosenOptions(box);
    box.classList.add('is-loading');
    return getVariants(box).then(function (variants) {
      box.classList.remove('is-loading');
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options || [];
        var ok = true;
        for (var j = 0; j < chosen.length; j++) { if (String(o[j]) !== chosen[j]) { ok = false; break; } }
        if (ok) { match = variants[i]; break; }
      }
      applyVariant(box, match);
      return match;
    });
  }

  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-product-row], [data-product-form]');
    if (!box) return;
    var sel = e.target.closest('select[data-variant-select]');
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      applyVariant(box, {
        id: sel.value, price: opt.dataset.price, available: opt.dataset.available === 'true',
        inventory: opt.dataset.inventory === '' ? null : opt.dataset.inventory, title: opt.dataset.title || opt.textContent
      });
      return;
    }
    if (e.target.closest('select[data-option-index]')) resolveVariant(box);
  });

  /* warm the variant list when a shopper starts using a multi-option row */
  ['focusin', 'pointerover'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var row = e.target.closest && e.target.closest('[data-product-row]');
      if (row && row.querySelector('select[data-option-index]')) getVariants(row);
    }, { passive: true });
  });

  /* ---------- cart count ---------- */
  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = countText(el, cart.item_count); });
        document.querySelectorAll('[data-cart-total]').forEach(function (el) { el.textContent = money(cart.total_price); });
        document.dispatchEvent(new CustomEvent('oilsu:cart-updated', { detail: cart }));
        return cart;
      });
  }
  window.oilsuRefreshCart = refreshCart;

  /* ---------- ajax add to cart ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add]');
    if (!btn || btn.disabled || btn.dataset.busy) return;
    e.preventDefault();
    var row = btn.closest('[data-product-row], [data-product-form]');
    if (!row) return;
    var needsResolve = !!row.querySelector('select[data-option-index]');
    var label = btn.dataset.label || btn.textContent;
    btn.dataset.label = label;
    btn.dataset.busy = '1';
    btn.textContent = 'Adding\u2026';
    var done = function (text) {
      btn.textContent = text;
      setTimeout(function () { if (!btn.disabled) btn.textContent = label; delete btn.dataset.busy; }, 1600);
    };
    (needsResolve ? resolveVariant(row) : Promise.resolve(null)).then(function () {
      var sel = row.querySelector('select[data-variant-select]') || row.querySelector('[data-variant-id]');
      var id = sel ? sel.value : '';
      if (!id || btn.disabled) { delete btn.dataset.busy; if (!btn.disabled) btn.textContent = label; return; }
      btn.textContent = 'Adding\u2026';
      var qtyEl = row.querySelector('[data-qty-input]');
      var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
      })
        .then(function (r) { return r.json().then(function (b) { if (!r.ok) throw b; return b; }); })
        .then(function () {
          if (qtyEl) qtyEl.value = qtyEl.min || 1;
          done('Added \u2713');
          return refreshCart();
        })
        .catch(function (err) { done(err && err.description ? 'Not available' : 'Try again'); });
    });
  });

  /* ---------- cart line quantity changes (cart page) ---------- */
  var lineTimer;
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line]');
    if (!input) return;
    clearTimeout(lineTimer);
    lineTimer = setTimeout(function () {
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(input.dataset.cartLine), quantity: Math.max(0, parseInt(input.value, 10) || 0) })
      }).then(function () { window.location.reload(); });
    }, 400);
  });

  /* ---------- predictive search ---------- */
  document.querySelectorAll('[data-predictive]').forEach(function (box) {
    var input = box.querySelector('input[name="q"]');
    var out = box.querySelector('[data-suggest]');
    var reset = box.querySelector('[data-search-reset]');
    if (!input || !out) return;
    var timer;
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { out.hidden = true; out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) { out.hidden = true; out.innerHTML = ''; return; }
            out.innerHTML = items.map(function (p) {
              var price = p.price ? money(Math.round(parseFloat(p.price) * 100)) : '';
              return '<a href="' + esc(p.url) + '"><span>' + esc(p.title) + '</span><span class="ot-mono">' + price + '</span></a>';
            }).join('');
            out.hidden = false;
          })
          .catch(function () { out.hidden = true; });
      }, 180);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') out.hidden = true; });
    if (reset) reset.addEventListener('click', function () { input.value = ''; out.hidden = true; out.innerHTML = ''; input.focus(); });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) out.hidden = true; });
  });

  /* ---------- header: mega menu + mobile toggle ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var menus = header.querySelectorAll('details[data-mm]');
    menus.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) menus.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    var closeAll = function () { menus.forEach(function (d) { d.open = false; }); };
    document.addEventListener('click', function (e) { if (!header.contains(e.target)) closeAll(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = header.querySelector('details[data-mm][open]');
      if (open) { open.open = false; open.querySelector('summary').focus(); }
    });
    var desktop = window.matchMedia('(min-width: 1101px)');
    menus.forEach(function (d) {
      var t;
      d.parentElement.addEventListener('mouseenter', function () { if (desktop.matches) { clearTimeout(t); d.open = true; } });
      d.parentElement.addEventListener('mouseleave', function () { if (desktop.matches) { t = setTimeout(function () { d.open = false; }, 160); } });
    });
    var burger = header.querySelector('[data-menu-toggle]');
    if (burger) burger.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.textContent = open ? 'Close' : 'Menu';
    });
  }

  /* ---------- collection filters collapse on small screens ---------- */
  var fbox = document.querySelector('[data-filterbox]');
  if (fbox && window.matchMedia('(max-width: 900px)').matches) fbox.open = false;
  if (fbox) fbox.querySelector('summary').addEventListener('click', function (e) {
    if (window.matchMedia('(min-width: 901px)').matches) e.preventDefault();
  });

  /* ---------- ingredient dictionary ---------- */
  var dict = document.querySelector('[data-oilsu-dict-section]');
  if (dict) {
    var table = dict.querySelector('table');
    if (table && !dict.querySelector('#od-q')) {
      var tbody = table.tBodies[0];
      var rows = Array.prototype.slice.call(tbody.rows);
      var norm = function (s) { return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\u2082/g, '2').toLowerCase(); };
      var data = rows.map(function (r) {
        var c = r.cells;
        var txt = function (i) { return c[i] ? c[i].textContent.trim() : ''; };
        return { el: r, s: norm(r.textContent), type: txt(1), part: txt(3), origin: txt(4), letter: norm(txt(0)).charAt(0).toUpperCase() };
      });
      var q = dict.querySelector('[data-dict-q]');
      var count = dict.querySelector('[data-dict-count]');
      var selects = {
        type: dict.querySelector('[data-dict-f="type"]'),
        part: dict.querySelector('[data-dict-f="part"]'),
        origin: dict.querySelector('[data-dict-f="origin"]')
      };
      var fill = function (sel, key, top) {
        if (!sel) return;
        var counts = {};
        data.forEach(function (d) { if (d[key]) counts[d[key]] = (counts[d[key]] || 0) + 1; });
        Object.keys(counts).sort(function (a, b) { return top ? counts[b] - counts[a] : a.localeCompare(b); })
          .forEach(function (k) { var o = document.createElement('option'); o.value = k; o.textContent = k + ' (' + counts[k] + ')'; sel.appendChild(o); });
      };
      fill(selects.type, 'type'); fill(selects.part, 'part', true); fill(selects.origin, 'origin', true);
      var az = dict.querySelector('[data-dict-az]');
      var letter = '';
      if (az) {
        var have = {};
        data.forEach(function (d) { have[d.letter] = 1; });
        'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(function (L) {
          var b = document.createElement('button'); b.type = 'button'; b.textContent = L; b.disabled = !have[L];
          b.addEventListener('click', function () {
            letter = letter === L ? '' : L;
            az.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-on', x.textContent === letter); });
            run();
          });
          az.appendChild(b);
        });
      }
      var params = new URLSearchParams(window.location.search);
      if (q && params.get('q')) q.value = params.get('q');
      Object.keys(selects).forEach(function (k) { if (selects[k] && params.get(k)) selects[k].value = params.get(k); });
      var run = function () {
        var t = norm(q ? q.value.trim() : '');
        var f = {}; Object.keys(selects).forEach(function (k) { f[k] = selects[k] ? selects[k].value : ''; });
        var n = 0;
        data.forEach(function (d) {
          var ok = (!t || d.s.indexOf(t) > -1) && (!f.type || d.type === f.type) && (!f.part || d.part === f.part) &&
                   (!f.origin || d.origin === f.origin) && (!letter || d.letter === letter);
          d.el.hidden = !ok; if (ok) n++;
        });
        if (count) count.textContent = n + ' of ' + data.length + ' ingredients';
      };
      var timer;
      if (q) q.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 120); });
      Object.keys(selects).forEach(function (k) { if (selects[k]) selects[k].addEventListener('change', run); });
      var reset = dict.querySelector('[data-dict-reset]');
      if (reset) reset.addEventListener('click', function () {
        if (q) q.value = ''; letter = '';
        Object.keys(selects).forEach(function (k) { if (selects[k]) selects[k].value = ''; });
        if (az) az.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-on'); });
        run();
      });
      Array.prototype.forEach.call(table.tHead.rows[0].cells, function (th, i) {
        th.tabIndex = 0;
        var sort = function () {
          var asc = th.getAttribute('aria-sort') !== 'ascending';
          Array.prototype.forEach.call(table.tHead.rows[0].cells, function (x) { x.removeAttribute('aria-sort'); });
          th.setAttribute('aria-sort', asc ? 'ascending' : 'descending');
          data.slice().sort(function (a, b) {
            var x = a.el.cells[i].textContent.trim().toLowerCase(), y = b.el.cells[i].textContent.trim().toLowerCase();
            return (x < y ? -1 : x > y ? 1 : 0) * (asc ? 1 : -1);
          }).forEach(function (d) { tbody.appendChild(d.el); });
        };
        th.addEventListener('click', sort);
        th.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sort(); } });
      });
      run();
    }
  }

  /* ---------- quote requests: prefill the contact form from ?product= ---------- */
  var qp = new URLSearchParams(window.location.search).get('product');
  var body = qp && document.querySelector('textarea[name="contact[body]"]');
  if (body && !body.value) body.value = 'Quote request: ' + window.location.origin + root + 'products/' + qp + '\nSize / quantity needed: ';
})();
